import _extends from "@babel/runtime/helpers/extends";
import { Box, SkeletonGroup, SkeletonRectangle, Text, Tooltip } from '@wix/design-system';
import React, { useCallback, useContext } from 'react';
import { CollapseContext } from '../../core/collapse-list/collapse-list';
import { CollapseListItem } from '../../core/collapse-list-item';
export const A11yPageListItem = /*#__PURE__*/React.memo(_ref => {
  let {
    id,
    title,
    suffix,
    isLoading = false,
    disabled = false,
    children,
    badgeText,
    badgeTooltipContent,
    onBadgeTooltipShow,
    issueCount,
    subtitle,
    showBadge = true,
    ...rest
  } = _ref;
  const atoms = useContext(CollapseContext);
  if (!atoms) {
    throw new Error('A11yPageListItem must be inside CollapseList.');
  }
  const renderSkeleton = useCallback(() => {
    return /*#__PURE__*/React.createElement(SkeletonGroup, null, /*#__PURE__*/React.createElement(SkeletonRectangle, {
      height: "18px",
      width: "60px"
    }));
  }, []);
  const renderIssuesText = useCallback(() => {
    return /*#__PURE__*/React.createElement(Tooltip, {
      content: badgeTooltipContent,
      disabled: !badgeTooltipContent,
      size: "small",
      onShow: onBadgeTooltipShow
    }, /*#__PURE__*/React.createElement(Text, {
      ellipsis: true,
      size: "tiny",
      weight: "thin",
      light: true,
      secondary: true
    }, badgeText));
  }, [badgeText, badgeTooltipContent, onBadgeTooltipShow]);
  const renderSuffix = useCallback(() => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, isLoading ? renderSkeleton() : /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      gap: "SP1",
      height: "18px",
      verticalAlign: "middle"
    }, showBadge && badgeText && renderIssuesText(), suffix));
  }, [isLoading, renderSkeleton, showBadge, badgeText, renderIssuesText, suffix]);
  const renderTitle = useCallback(() => {
    return typeof title === 'string' ? /*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "normal"
    }, title) : title;
  }, [title]);
  const renderSubtitle = useCallback(() => {
    return typeof subtitle === 'string' ? /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "thin",
      secondary: true
    }, subtitle) : subtitle;
  }, [subtitle]);
  return /*#__PURE__*/React.createElement(CollapseListItem, _extends({
    disabled: disabled || isLoading,
    id: id,
    subtitle: renderSubtitle(),
    suffix: renderSuffix(),
    title: renderTitle()
  }, rest), children);
});
//# sourceMappingURL=a11y-page-list-item.js.map